import React from 'react';
import { Row } from 'antd';
import { FormField } from 'common';

const PropertyDocumentTypeFormFields: React.FC<{
  tabNamePrefix: string;
  rowStyle?: string;
  recordedDocumentsFieldNameSuffix?: string;
}> = ({
  tabNamePrefix,
  rowStyle = '',
  recordedDocumentsFieldNameSuffix = '',
}) => {
  const assessmentFieldName = `${tabNamePrefix}.assessment`;
  const recordedDocumentsFieldName = `${tabNamePrefix}.recordedDocuments${recordedDocumentsFieldNameSuffix}`;
  const filedLiensFieldName = `${tabNamePrefix}.filedLiens`;

  return (
    <>
      <Row type="flex" align="middle" className={rowStyle}>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name={assessmentFieldName}
          id={assessmentFieldName}
          tooltip="Assessment information"
        >
          Assessment
        </FormField>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name={recordedDocumentsFieldName}
          id={recordedDocumentsFieldName}
          tooltip="Recorded Documents"
        >
          Recorded Documents
        </FormField>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name={filedLiensFieldName}
          id={filedLiensFieldName}
          tooltip="Filed Liens"
        >
          Filed Liens
        </FormField>
      </Row>
    </>
  );
};

export default React.memo(PropertyDocumentTypeFormFields);
